export default __webpack_public_path__ + "static/media/High-Precision.735a2a0e.jpg";